import React from 'react'
import PropTypes from 'prop-types'

import { Input } from '@material-ui/core'

export default class BaseInput extends React.Component {
  static propTypes = {
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    onChange: PropTypes.func.isRequired,
  }

  static defaultProps = {
    value: undefined,
  }

  onChange = (e) => {
    this.props.onChange(this.parse(e.target.value))
  }

  parse = (v) => (v)

  inputProps = () => ({})

  render() {
    const { value, onChange: _, ...rest } = this.props
    const v = (value === undefined) ? '' : value
    return (
      <Input
        {...this.inputProps()}
        value={v}
        onChange={this.onChange}
        {...rest}
      />
    )
  }
}
